import api from './api';
import {
  UserPreferences,
  LanguageInfo,
  UserModesResponse,
  AccessibilitySettings,
  TranslationRequest,
  TranslationResponse,
  SimplifyRequest,
  SimplifyResponse,
  PreferencesUpdateRequest,
} from '../types/preferences';

export const preferencesApi = {
  // Preferences
  getPreferences: async (): Promise<UserPreferences> => {
    const response = await api.get('/preferences/me');
    return response.data;
  },

  updatePreferences: async (data: PreferencesUpdateRequest): Promise<UserPreferences> => {
    const response = await api.put('/preferences/me', data);
    return response.data;
  },

  resetPreferences: async (): Promise<UserPreferences> => {
    const response = await api.post('/preferences/reset');
    return response.data;
  },

  // Languages
  getSupportedLanguages: async (): Promise<LanguageInfo[]> => {
    const response = await api.get('/preferences/languages');
    // API returns { languages: [...] }, extract the array
    return response.data.languages ?? response.data;
  },

  setLanguage: async (language: string): Promise<UserPreferences> => {
    const response = await api.put('/preferences/language', { language });
    return response.data;
  },

  // User Modes
  getUserModes: async (): Promise<UserModesResponse> => {
    const response = await api.get('/preferences/modes');
    return response.data;
  },

  setUserMode: async (mode: string): Promise<UserPreferences> => {
    const response = await api.put('/preferences/mode', { mode });
    return response.data;
  },

  // Accessibility
  getAccessibilitySettings: async (): Promise<AccessibilitySettings> => {
    const response = await api.get('/preferences/accessibility');
    return response.data;
  },

  // Translation
  translate: async (data: TranslationRequest): Promise<TranslationResponse> => {
    const response = await api.post('/preferences/translate', data);
    return response.data;
  },

  // Simplify (for layperson mode)
  simplifyText: async (data: SimplifyRequest): Promise<SimplifyResponse> => {
    const response = await api.post('/preferences/simplify', data);
    return response.data;
  },

  // Theme
  setTheme: async (theme: 'light' | 'dark' | 'system'): Promise<UserPreferences> => {
    const response = await api.put('/preferences/theme', { theme });
    return response.data;
  },
};
